var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMexico(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mexico_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 5.5H.43v22h36.896v-22h-12.3z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.729 5.5H.431v22h12.298v-22z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.028 5.5H12.729v22h12.299v-22z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42 16.5c0 1.708 1.548 3.093 3.459 3.093 1.91 0 3.459-1.385 3.459-3.093v-1.032H15.42V16.5z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49 14.437h-3.458c0-.57-.517-1.031-1.153-1.031-.637 0-1.153.462-1.153 1.031h-3.46c0 .57.555 1.031 1.192 1.031h-.038c0 .57.516 1.032 1.153 1.032 0 .57.516 1.03 1.153 1.03h2.306c.636 0 1.153-.46 1.153-1.03.636 0 1.153-.462 1.153-1.032h-.039c.637 0 1.192-.461 1.192-1.03z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Mexico_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.43)",
    d: "M0 0h36.896v33H0z"
  })))));
}

export default __webpack_public_path__ + "7919f35b56148bee9acd336b95d8478c.svg";
export { SvgMexico as ReactComponent };